<template>
  <b-modal title="Medições de Espessura" v-model="show" size="xl">
    <b-container fluid>
      <b-row>
        <b-col cols="6">
          <b-row class="mt-2">
            <b-col cols="12">
              <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="2" label-align-sm="right">
                <b-form-input id="descricao" v-model="template.descricao" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="12">
              <b-form-group label="Local:" label-for="local" label-cols-sm="2" label-align-sm="right">
                <b-form-input id="local" v-model="template.local" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="6">
              <b-form-group label="Posição:" label-for="posicao" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="posicao" v-model="template.posicao" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Ano:" label-for="ano" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="ano" v-model="template.ano" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="6">
              <b-form-group label="Comprim.:" label-for="comprimento" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="comprimento" v-model="template.comprimento" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Périmetro:" label-for="perimetro" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="perimetro" v-model="template.perimetro" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="6">
              <b-form-group label="Diâmetro:" label-for="diametro" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="diametro" v-model="template.diametro" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="PMTA:" label-for="pmta" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="pmta" v-model="template.pmta" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col cols="6">
              <b-form-group label="Calota A:" label-for="calotaa" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="calotaa" v-model="template.calotaa" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Calota B:" label-for="calotab" label-cols-sm="4" label-align-sm="right">
                <b-form-input id="calotab" v-model="template.calotab" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- :::::::::::::::::::::::::::: TABELA DE MEDIÇÕES :::::::::::::::::::::::::::: -->
        <b-col cols="6">
          <b-table
            id="table-medicoes"
            sticky-header
            style="max-height: 330px"
            bordered
            hover
            small
            head-variant="light"
            :items="template.itens"
            :fields="fields.medicoes"
          >
            <template #cell(a)="data">
              <div>
                <b-form-input v-model="data.item.a" />
              </div>
            </template>
            <template #cell(b)="data">
              <div>
                <b-form-input v-model="data.item.b" />
              </div>
            </template>
            <template #cell(c)="data">
              <div>
                <b-form-input v-model="data.item.c" />
              </div>
            </template>
            <template #cell(d)="data">
              <div>
                <b-form-input v-model="data.item.d" />
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-med-modal ref="templateMedicoes" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="primary" @click="adicionar()"> <b-icon icon="plus-circle" aria-hidden="true" /> </b-button>
      <b-button variant="danger" @click="remover()"> <b-icon icon="dash-circle" aria-hidden="true" /> </b-button>
      <b-button variant="info" @click="carregar()">Carregar</b-button>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useTemplateStore } from "@/stores/TemplateStore";
import Notificacao from "@/models/Notificacao";
import Medicoes from "@/models_reports/Medicoes";
import TableFields from "@/tools/TableFields";
import MedicaoEspessura from "@/models_reports/MedicaoEspessura";
import MedicoesTemplateModal from "@/components/modals/template/MedicoesTemplateModal";

export default {
  name: "ModalDeMedicoesME",

  components: {
    "template-med-modal": MedicoesTemplateModal,
  },

  data() {
    return {
      show: false,
      template: new Medicoes(),
      me: new MedicaoEspessura(),
      fields: new TableFields(),
    };
  },

  methods: {
    templates() {
      this.$refs.templateMedicoes.call();
    },

    loadTemplate(template) {
      this.template = template;
      this.me.itens = template.itens;
      this.$emit("loadMedicoes", template.itens);
    },

    carregar() {
      this.$emit("loadMedicoes", this.template.itens);
      this.show = !this.show;
    },

    adicionar() {
      this.template.itens.push({
        a: "0.0",
        b: "0.0",
        c: "0.0",
        d: "0.0",
      });
    },

    remover() {
      this.template.itens.pop();
    },

    salvar() {
      if (this.template.id != 0) {
        this.templateStore.ALTERAR_MEDICOES(this.template).then(() => {
          for (var i = 0; i < this.template.itens.length; i++) {
            this.templateStore.ALTERAR_MEDICOES_ITEM(this.template.itens[i]);
          }
          this.store.NOTIFICAR(new Notificacao("Medições salva no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        //pode ser implementado no futuro!
      }
    },

    call(me) {
      this.me = me;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();

    return {
      store,
      templateStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
